import React, { useRef } from "react";

let fieldSequence = 0;

// IDs belong to a mounted control, not just its name: short attachment forms
// can contain identical Formik paths on the same page.
export const useFieldFeedback = (props, error, hint) => {
  const generatedId = useRef(null);
  if (generatedId.current === null) {
    fieldSequence += 1;
    generatedId.current = `signal-field-${fieldSequence}`;
  }
  const id = props.id || generatedId.current;
  const descriptions = [
    props["aria-describedby"],
    error ? `${id}-error` : null,
    hint ? `${id}-hint` : null,
  ].filter(Boolean).join(" ");

  return {
    id,
    "aria-invalid": error ? true : props["aria-invalid"],
    "aria-describedby": descriptions || undefined,
  };
};

export const errorMessages = (error) => {
  if (typeof error === "string") return error ? [error] : [];
  if (Array.isArray(error)) return error.filter((message) => typeof message === "string" && message);
  return [];
};

const FieldFeedback = ({ id, error, hint }) => (
  <React.Fragment>
    {error ? (
      <p id={`${id}-error`} className="custom_error signal-field-error" data-signal-error-for={id}>
        {Array.isArray(error) ? errorMessages(error).join(" · ") : error}
      </p>
    ) : null}
    {hint ? <p id={`${id}-hint`} className="custom_hint">{hint}</p> : null}
  </React.Fragment>
);

export default FieldFeedback;
